module.exports = __webpack_public_path__ + "img/s7Model2M.79612cfd.webp";